import { Component, Injector, Input, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { AppComponentBase } from '@shared/app-component-base';
import { GerarFichaPacienteDto, GraficoMonitoramentoEnum, PacienteDto, PacienteServiceProxy } from '@shared/service-proxies/service-proxies';
import * as FileSaver from 'file-saver';
import * as printJS from 'print-js'
import { transformB64ToBlob } from '@shared/base64-to-blob';
import { ChartList } from '@shared/model/grafico/chart-list.model';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-download-ficha-paciente',
  templateUrl: './download-ficha-paciente.component.html',
  styleUrls: ['./download-ficha-paciente.component.scss']
})
export class DownloadFichaPacienteComponent extends AppComponentBase implements OnInit {

  @Input() paciente: PacienteDto;
  @Input() icon: string = "hgi hgi-stroke hgi-download-04 icon-color-black";
  @Input() label: string = "Downalod";
  @Input() title: string = "Fazer download da ficha do paciente";
  @Input() isDownalod: boolean = true;

  public opcaoGraficos: ChartList = new ChartList();
  public ficha: GerarFichaPacienteDto = new GerarFichaPacienteDto();

  constructor(
    injector: Injector,
    private readonly _pacienteService: PacienteServiceProxy,
    public bsModalRef: BsModalRef
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.ficha.graficos = [];
    this.ficha.pacienteId = this.paciente.id;
  }

  protected download() {
    abp.ui.setBusy();
    this.ficha.pacienteId = this.paciente.id;
    this._pacienteService
      .gerarPdfFichaPaciente(this.ficha)
      .pipe(
        finalize(() => {
          abp.ui.clearBusy();
        })
      )
      .subscribe((x) => {
        if (this.isDownalod) {
          const blob = transformB64ToBlob(x, { type: "application/pdf" });
          FileSaver.saveAs(blob, `Ficha ${this.paciente.nome}.pdf`);
          window.open(window.URL.createObjectURL(blob));
        } else {
          printJS({ printable: x, type: 'pdf', base64: true });
        }
        this.bsModalRef.hide();
      });
  }

  protected updateList(enumGrafico: GraficoMonitoramentoEnum, value: boolean): void {
    if (value)
      this.ficha.graficos.push(enumGrafico);
    else
      this.ficha.graficos = [...this.ficha.graficos.filter(x => x != enumGrafico)];
  }
}
